import { useState } from 'react';

interface AITerminalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function AITerminal({ isOpen, onClose }: AITerminalProps) {
  const [messages, setMessages] = useState<string[]>([]);
  const [inputMessage, setInputMessage] = useState('');

  const handleSendMessage = async () => {
    if (!inputMessage.trim()) return;
    
    // Add user message to chat
    setMessages(prev => [...prev, `You: ${inputMessage}`]);
    
    try {
      const response = await fetch('https://lyriaterminal.onrender.com/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: inputMessage }),
      });
      
      const data = await response.json();
      setMessages(prev => [...prev, `Lyria: ${data.response}`]);
    } catch (error) {
      setMessages(prev => [...prev, 'Lyria: Sorry, I encountered an error. Please try again.']);
    }
    
    setInputMessage('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-quantum-dark border border-quantum-primary/30 rounded-lg w-full max-w-2xl h-[600px] flex flex-col">
        <div className="p-4 border-b border-quantum-primary/30 flex justify-between items-center">
          <h3 className="text-quantum-primary font-bold">AI Agent Terminal</h3>
          <button
            onClick={onClose}
            className="text-quantum-light/60 hover:text-quantum-light"
          >
            ✕
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          <div className="text-quantum-primary/80">
            I am Lyria, guardian of Quantum Genesis. How can I help you?
          </div>
          {messages.map((msg, index) => (
            <div key={index} className="text-quantum-light/80">
              {msg}
            </div>
          ))}
        </div>
        <div className="p-4 border-t border-quantum-primary/30">
          <div className="flex gap-2">
            <input
              type="text"
              value={inputMessage}
              onChange={(e) => setInputMessage(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
              placeholder="Type your message..."
              className="flex-1 bg-quantum-dark/50 border border-quantum-primary/30 rounded px-4 py-2 text-quantum-light focus:outline-none focus:border-quantum-primary"
            />
            <button
              onClick={handleSendMessage}
              className="quantum-button !bg-quantum-primary/90"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 